import React from 'react';
import { Zap } from 'lucide-react';
export const TopBar = () => {
  return <div className="bg-black text-white py-2 px-4 text-center text-xs sm:text-sm font-medium tracking-wide flex items-center justify-center gap-2 z-50 relative" data-id="element-332">
      <Zap size={16} className="text-gold-500" data-id="element-333" />
      <span data-id="element-334">Para la mujer que está agotada de su propia cabeza.</span>
    </div>;
};